export default "__VITE_ASSET__BelDGmRm__"